/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { IoMdAdd } from "react-icons/io";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { GetAllipAddress, DeleteIpAddress } from "../Features/AllowIpData";
import { RootState, AppDispatch } from "../Appstore/store";
import AddallowIPmodal from "../Components/AddallowIPmodal";
import UpdateAllowIP from "../Components/UpdateAllowIP";
import { setIsLoading } from "../Features/loadingSlice";
import { toast } from "sonner";
import { RenderPaginationButtons } from "../Components/Paginations";
import HelpText from "../Components/HelpText";

function Allowip() {
  const [showAddAllowIpModal, setshowAddAllowIpModal] =
    useState<boolean>(false);
  const [showUpdateAllowIpModal, setUpdateAllowIpModal] =
    useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const limit = 10;
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [search, setSearch] = useState<string>("");
  const dispatch = useDispatch<AppDispatch>();

  const { allowipdata, info, loading } = useSelector(
    (state: RootState) => state.allowIp
  );

  const [debouncedSearch, setDebouncedSearch] = useState<string>(search);
  const [currentIpData, setCurrentIpData] = useState<{
    ip: string;
    status: number;
  } | null>(null);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(search.trim());
    }, 700);

    return () => {
      clearTimeout(handler);
    };
  }, [search]);

  useEffect(() => {
    dispatch(
      GetAllipAddress({ search: debouncedSearch, page: currentPage, limit })
    );
  }, [dispatch, debouncedSearch, currentPage, limit]);

  const openDeleteModal = (id: number) => {
    setSelectedId(id);
    setShowDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
    setSelectedId(null);
  };

  useEffect(() => {
    if (currentPage > info?.total_page!) setCurrentPage(info?.total_page || 1);
  }, [info]);

  const confirmDelete = async () => {
    if (selectedId !== null) {
      dispatch(setIsLoading(true));
      const resp: any = await dispatch(DeleteIpAddress({ id: selectedId }));
      if (resp?.payload?.status === "success")
        toast.success(resp?.payload?.message || "");
      else toast.error(resp?.payload?.message || "");
      setTimeout(() => {
        dispatch(setIsLoading(false));
      }, 500);
      dispatch(GetAllipAddress({ search: "", page: 1, limit: 10 }));
    }
    closeDeleteModal();
  };

  const addAllowIprecord = () => {
    setshowAddAllowIpModal(true);
  };

  const closeaddAllowIprecordModal = () => {
    setshowAddAllowIpModal(false);
  };

  const UpdateIprecord = (id: number) => {
    setSelectedId(id);
    const ipData = allowipdata.find((item) => item.id === id);

    if (ipData) {
      setCurrentIpData({ ip: ipData.ip || "", status: ipData.status ?? 0 });
    }
    setUpdateAllowIpModal(true);
  };

  const closeUpdateAllowIprecordModal = () => {
    setUpdateAllowIpModal(false);
    setCurrentIpData(null);
  };

  const formatDate = (dateString: string | undefined): string => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const handlePageChange = (page: number) => {
    if (page > 0 && page <= (info?.total_page || 1)) {
      setCurrentPage(page);
    }
  };

  return (
    <>
      <div className="wrapper">
        <div className="content-wrapper">
          <section className="content">
            <div className="container-fluid">
              <div className="card mt-4">
                <div className="card-header bg-white p-3 d-md-flex justify-content-md-between align-items-center">
                  <h2 className="w-100 text-md-start text-center mb-md-2 mb-3 fs-3">
                    IP Address
                  </h2>
                  <div className="d-sm-flex justify-content-between align-items-center mb-md-0 mb-3">
                    <div className="input-group input-group-sm pe-sm-3 mb-sm-0 mb-3 search-input">
                      <input
                        type="search"
                        name="table_search"
                        className="form-control float-right height-40px shadow-none"
                        placeholder="Search"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                      />
                      <div className="input-group-append">
                        <button
                          type="submit"
                          className="btn border cursor-pointer-none"
                        >
                          <i className="fas fa-search" />
                        </button>
                      </div>
                    </div>
                    <div>
                      <div className="">
                        <button
                          data-tooltip-id="Add_Btn"
                          onClick={addAllowIprecord}
                          className="border-0  bg-button btn btn-primary text-white rounded-0 text-secondary w-100 px-2 py-2 fw-semibold d-flex justify-content-center align-items-center"
                        >
                          <IoMdAdd className="fs-4" />
                          <HelpText id="Add_Btn" content="Add Ip Address" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-body  p-0">
                  <>
                    <div className="table-responsive">
                      <table className="table table-hover table-bordered text-nowrap">
                        <thead>
                          <tr>
                            <th className="ps-3 sr-no">SR No</th>
                            <th className="text-center">IP</th>
                            <th className="text-center status">Status</th>
                            <th className="text-center createdat">CreatedAt</th>
                            <th className="text-center updatedat">UpdatedAt</th>
                            <th className="text-center action">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {loading ? (
                            <tr>
                              <td colSpan={6} height={100}>
                                <div className="text-center">
                                  <div className="loader"></div>
                                </div>
                              </td>
                            </tr>
                          ) : !allowipdata || allowipdata.length === 0 ? (
                            <tr>
                              <td colSpan={6} height={50}>
                                <div className="text-center">
                                  <p className="mb-0 fs-5 fw-semibold">
                                    No data found
                                  </p>
                                </div>
                              </td>
                            </tr>
                          ) : (
                            allowipdata.map((item, index) => (
                              <tr key={index}>
                                <td className="ps-3">
                                  {(currentPage - 1) * limit + index + 1}
                                </td>
                                <td className="text-center">{item?.ip}</td>
                                <td
                                  className={`text-center ${item.status === 1
                                    ? "text-success fw-bold"
                                    : "text-danger fw-bold"
                                    }`}
                                >
                                  {item.status === 1 ? "Active" : "Deactive"}
                                </td>
                                <td className="text-center">
                                  {formatDate(item?.createdAt)}
                                </td>
                                <td className="text-center">
                                  {formatDate(item?.updatedAt)}
                                </td>

                                <td className="text-center">
                                  <button
                                    onClick={() => UpdateIprecord(item?.id!)}
                                    className="ms-1 bg-transparent border-0 text-primary fs-5"
                                  >
                                    <i data-tooltip-id={"Update_Btn_"+index} className="fa-solid fa-pen"></i>
                                    <HelpText id={"Update_Btn_"+index} content="Update Ip Address"/>
                                    </button>
                                  <button
                                    onClick={() => openDeleteModal(item?.id!)}
                                    className="ms-1 bg-transparent border-0 text-danger fs-5"
                                  >
                                    <i data-tooltip-id={"Delete_Btn_"+index} className="fa-solid fa-trash"></i>
                                    <HelpText id={"Delete_Btn_"+index} content="Delete Ip Address"/>
                                    </button>
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>

                    {!allowipdata || allowipdata.length === 0 ? (
                      <div></div>
                    ) : (
                      <div className="pagination d-flex flex-wrap justify-content-center align-items-center my-4 mx-3">
                        <RenderPaginationButtons
                          info={info}
                          currentPage={currentPage}
                          handlePageChange={handlePageChange}
                        />
                      </div>
                    )}
                  </>
                </div>
              </div>
            </div>
          </section>

          <Modal show={showDeleteModal} onHide={closeDeleteModal} centered>
            <div className="p-3">
              <div className="text-center">
                <i
                  style={{ fontSize: "50px" }}
                  className="fs-1 text-danger bi bi-info-circle"
                ></i>
              </div>
              <Modal.Header className="d-block border-0 p-2 text-center">
                <Modal.Title>Confirm Delete</Modal.Title>
              </Modal.Header>
              <Modal.Body className="border-0 text-center p-2">
                Are you sure you want to delete this IP Address.
              </Modal.Body>
              <Modal.Footer className="border-0 justify-content-center">
                <button className="btn btn-danger" onClick={confirmDelete}>
                  Delete
                </button>
                <button
                  className="btn btn-secondary"
                  onClick={closeDeleteModal}
                >
                  Cancel
                </button>
              </Modal.Footer>
            </div>
          </Modal>

          <AddallowIPmodal
            show={showAddAllowIpModal}
            onHide={closeaddAllowIprecordModal}
          />

          <UpdateAllowIP
            show={showUpdateAllowIpModal}
            onHide={closeUpdateAllowIprecordModal}
            selectedId={selectedId}
            currentIpData={currentIpData}
          />
        </div>
      </div>
    </>
  );
}

export default Allowip;
